<template>
  <div>
    <div class="p-3 card mb-3">
      <label class="titlePage">Cidades de Provas Importadas</label>

      <fccTable
        striped
        hover
        responsive
        search
        pagination
        :fields="fields"
        :items="cidadesImportadas"
        :porPage="itemsPorPage"
        @row-selected="selecionaLinha"
      >
      </fccTable>

      <div class="text-right mb-3">
        <fccButton @click="excluirCidadesImportadas" :disabled="dadosSelecionados.length <= 0">{{
          labelsSystem.excluir
        }}</fccButton>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'

export default {
  props: ['cidadesImportadas'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'data', label: 'Data de Aplicação', sortable: true },
        { key: 'cidade', label: 'Cidade de Provas', sortable: true },
        { key: 'ncolegio', label: 'Nº Colégios', sortable: true },
        { key: 'nsalas', label: 'Nº Salas', sortable: true },
        { key: 'ncandidatos', label: 'Nº Candidatos', sortable: true },
        { key: 'tipohorario', label: 'Tipo de Horário', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataimportacao', label: 'Data da Importação', sortable: true }
      ],
      itemsPorPage: 10,
      dadosSelecionados: []
    }
  },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    excluirCidadesImportadas() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        listaIdDataCidade: this.dadosSelecionados.map((item) => item.iddatacidade)
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          fccStore.state.baseUrlLocalDeProva + `LocalExameCidade/ExcluirCidadesImportadas`,
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.$emit('cidade-excluida')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>
